/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_BadgeInputs */

const en_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Governed Career Tools`)
};

const de_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-gesteuerte Karriere-Tools`)
};

const fr_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils de carrière propulsés par l'IA`)
};

const es_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de carrera con IA`)
};

const it_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti di carriera con IA`)
};

const nl_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-aangedreven carrièretools`)
};

const pl_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narzędzia kariery napędzane AI`)
};

const fi_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoälypohjaiset uratyökalut`)
};

const da_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-drevne karriereværktøjer`)
};

const sv_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-drivna karriärverktyg`)
};

/**
* | output |
* | --- |
* | "AI-Governed Career Tools" |
*
* @param {Landing_Hero_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_hero_badge = /** @type {((inputs?: Landing_Hero_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_hero_badge(inputs)
	if (locale === "fr") return fr_landing_hero_badge(inputs)
	if (locale === "es") return es_landing_hero_badge(inputs)
	if (locale === "it") return it_landing_hero_badge(inputs)
	if (locale === "nl") return nl_landing_hero_badge(inputs)
	if (locale === "pl") return pl_landing_hero_badge(inputs)
	if (locale === "fi") return fi_landing_hero_badge(inputs)
	if (locale === "da") return da_landing_hero_badge(inputs)
	if (locale === "sv") return sv_landing_hero_badge(inputs)
	return en_landing_hero_badge(inputs)
});